import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    options: {
        sort: [],
        tab: [],
        select: [],
        table: {
            name: '',
            column: [],
        },
    },
    selectedValue: {
        tab: '',
        select: {},
        selectedIds: [],
    },
    modal: {
        confirm: false,
        delete: false,
        export: false,
        filter: false,
        advanceFilter: false,
        printLabel: false,
        printManifest: false,
        scan: false,
        addAWB: false,
    },
    query: {
        search: '',
        page: 1,
        limit: 20,
        order_by: 'created_at',
        order_type: 'desc',
    },
    reload: false,
    confirmationMessage: '',
}

export const listSlice = createSlice({
    name: 'list',
    initialState: initialState,
    reducers: {
        setOptions: (state, action) => ({
            ...state,
            options: { ...state.options, ...action.payload },
        }),
        setModal: (state, action) => ({
            ...state,
            modal: { ...state.modal, ...action.payload },
        }),
        setSelectedValue: (state, action) => ({
            ...state,
            selectedValue: { ...state.selectedValue, ...action.payload },
        }),
        setQuery: (state, action) => {
            let payload
            switch (action.payload.name) {
                case 'sort':
                    const splitSort = action.payload.value?.split('-')
                    payload = { order_by: splitSort[0], order_type: splitSort[1] }
                    break
                case 'search':
                case 'limit':
                    payload = payload = { [action.payload.name]: action.payload.value, page: 1 }
                    break
                case 'date':
                    payload = payload = {
                        start_date: action.payload.value[0],
                        end_date: action.payload.value[1],
                        page: 1,
                    }
                    break
                default:
                    payload = { [action.payload.name]: action.payload.value }
            }
            return {
                ...state,
                query: { ...state.query, ...payload },
            }
        },
        setQueryBulk: (state, action) => ({
            ...state,
            query: { ...state.query, ...action.payload },
        }),
        setReload: (state) => ({
            ...state,
            reload: !state.reload,
        }),
        setConfirmationMessage: (state, action) => ({
            ...state,
            confirmationMessage: action.payload,
        }),
    },
})

export const { setOptions, setModal, setQuery, setSelectedValue, setQueryBulk, setReload, setConfirmationMessage } =
    listSlice.actions

const listReducer = listSlice.reducer
export default listReducer
